
import {Component, Prop, Vue} from "vue-property-decorator";

import {MdbsCore} from "@/api/tsclient";
import {translate} from "@/auxillary/translation";
import {stringify} from "@/auxillary/datafield.stringify";
import ReadonlyDataField from "@/models/ReadonlyDataField";
import EnumValueDefinitionDto = MdbsCore.EnumValueDefinitionDto;

import {findEnumValueSet, activeEnumValues} from "@/auxillary/enum.lookup";

@Component({
  name: 'LabValueFieldReadonly',
  components: {
  },
})
export default class LabValueFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  errorMessage: string = "";

  getEnumDisplayName(enumValue: EnumValueDefinitionDto) {
    return translate(enumValue.displayKey);
  }

  get labelField() {
    return this.displayName.length <= 4 ? this.displayName : ""
  }

  get labelAbove() {
    return this.displayName.length > 4 ? this.displayName : ""
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return true;
  }

  get value() {
    this.validateInput()
    const value = this.dataField.values.value;
    if (value === "unknown") {
      return "";
    }
    if (value === "not_executed") {
      return "";
    }
    return value;
  }

  get unit() {
    return this.dataField.values.unit
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  get canBeNotExecuted() {
    return this.field.definition.canBeNotExecuted ?? false;
  }

  get notExecuted() {
    return this.dataField.values.notExecuted
  }

  get unitDisplayName() {
    return "Einheit"; // TODO translate
  }

  get field() {
    return this.dataField;
  }

  get units() {
    const allowedUnits = this.field?.definition?.allowedUnits ?? [];
    const enums: EnumValueDefinitionDto[] = activeEnumValues(this.unitsEnum).filter(e => allowedUnits.includes(e.code)) ?? [];
    // eslint-disable-next-line no-unused-labels
    return enums; // TODO convert and trandslate
  }

  get unitsEnum() {
    return findEnumValueSet(this.dataField.definition.unitEnum);
  }

  get minValue() {
    return this.field.definition.min;
  }

  get maxValue() {
    return this.field.definition.max;
  }

  get decimalSeparator() {
    return this.field.definition.decimalSeparator || ',';
  }

  validateKeyPress(evt: KeyboardEvent) {
    let keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const keyPressed: string = evt.key;

    const value = this.dataField.values?.value;
    if (!value || (value && this.decimalSeparator && value.indexOf(this.decimalSeparator) == -1)) {
      keysAllowed.push(this.decimalSeparator)
    }

    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault()
    }
  }

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName;
  }

  validateInput() {
    const value = this.dataField.values?.value;
    if (value) {
      const intValue = Number.parseInt(value);
      if (this.minValue) {
        if (intValue < this.minValue) {
          this.errorMessage = "Minimalwert: " + this.minValue;
          return;
        }
      }
      if (this.maxValue) {
        if (intValue > this.maxValue) {
          this.errorMessage = "Maximalwert: " + this.maxValue;
          return;
        }
      }
    }
    this.errorMessage = "";
  }
}
